/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import CustomEditor from "../../../Module/Edittor/CustomEditorBuild";
import { getWordCountFromEditor } from "../../../Utils/utils";
import { showErrorSnackbar } from "../../../Action/snackbarAction";
import { useDispatch } from "react-redux";

// Same public API as before (props.value, props.setInputText, props.maxLength,
// props.isSetWordCount) so this is a drop-in replacement -- no callers need to change.
const TextEditor = (props) => {
  const dispatch = useDispatch();
  const editorRef = useRef(null);
  const prevDataRef = useRef(props?.value || "");
  const isProgrammaticUpdate = useRef(false);
  const prevWordCountRef = useRef(0);

  useEffect(() => {
    const initialText = props?.value || "";
    prevDataRef.current = initialText;
    prevWordCountRef.current = getWordCountFromEditor(initialText);

    // Keep the live editor in sync if `value` changes from outside
    // (e.g. switching between questions in a list).
    if (editorRef.current && editorRef.current.getData() !== initialText) {
      isProgrammaticUpdate.current = true;
      editorRef.current.setData(initialText);
    }
  }, [props?.value]);

  const handleEditorChange = (event, editor) => {
    if (isProgrammaticUpdate.current) {
      isProgrammaticUpdate.current = false;
      return;
    }

    const data = editor.getData();
    const currentWordCount = getWordCountFromEditor(data);
    const prevWordCount = prevWordCountRef.current;

    if (props.isSetWordCount === false) {
      prevDataRef.current = data;
      prevWordCountRef.current = currentWordCount;
      props.setInputText(data);
      return;
    }

    if (currentWordCount > props.maxLength && currentWordCount > prevWordCount) {
      dispatch(showErrorSnackbar(`Maximum ${props.maxLength} words allowed`));
      isProgrammaticUpdate.current = true;
      editor.setData(prevDataRef.current);
      return;
    }

    prevDataRef.current = data;
    prevWordCountRef.current = currentWordCount;
    props.setInputText(data);
  };

  return (
    <CKEditor
      editor={CustomEditor}
      data={props?.value || ""}
      onReady={(editor) => {
        editorRef.current = editor;
        editor.editing.view.change((writer) => {
          writer.setStyle(
            "min-height",
            "150px",
            editor.editing.view.document.getRoot()
          );
        });
      }}
      onChange={handleEditorChange}
    />
  );
};

export default TextEditor;